import { ReactNode } from 'react';
import styled from 'styled-components';

import { LabelText } from '../../common/LabelText/LabelText';
import { Box } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';
import { Text } from '../Text/Text';

export const ValueFrame = styled.div`
    background: ${theme.colors.background.subtle};
    border: none;
    box-shadow: 0px 0px 0px 1px ${theme.colors.border.subtle};
    width: 100%;
    padding: 6px 10px;
    margin: 0;
    border-radius: 6px;
    height: 32px;
    display: flex;
    gap: ${theme.space[8]};
    align-items: center;
    justify-content: space-between;
`;

interface ReadOnlyFieldProps {
    value: string;
    label?: string;
    leadingVisual?: ReactNode;
    trailingVisual?: ReactNode;
}

export const ReadOnlyField = ({ value, label, leadingVisual, trailingVisual }: ReadOnlyFieldProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={4}>
            {label ? <LabelText>{label}</LabelText> : null}
            <ValueFrame>
                <Box display="flex" gap={8} alignItems="center" width="100%" overflow="hidden">
                    {leadingVisual ? <div>{leadingVisual}</div> : null}
                    <Text
                        variant="small"
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'block',
                        }}
                    >
                        {value}
                    </Text>
                </Box>
                {trailingVisual ? <div>{trailingVisual}</div> : null}
            </ValueFrame>
        </Box>
    );
};
